module.exports = __webpack_public_path__ + "img/alert.eaa6b66b.svg";